import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {ModalInfoComponent} from '../../shared/components/modal-info/modal-info.component';

@Injectable()
export class VersionCheckService {
    private http = inject(HttpClient);
    private matDialog = inject(MatDialog);

    // this will be replaced by actual hash post-build.js
    private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

    /**
     * Checks in every set frequency the version of frontend application
     *
     * @param url
     * @param frequency - in milliseconds, defaults to 30 minutes  1000 * 60 * 30
     */
    public initVersionCheck(url, frequency = 1000 * 60) {

        // Check au démarrage
        this.checkVersion(url);

        // Vérification toutes les minutes
        setInterval(() => {
            this.checkVersion(url);
        }, frequency);
    }

    /**
     * Will do the call and check if the hash has changed or not
     *
     * @param url
     */
    private checkVersion(url) {
        // timestamp these requests to invalidate caches
        this.http.get(url + '?t=' + new Date().getTime())
            .subscribe(
                (response: any) => {
                    console.log('CheckVersion Response', response);
                    const hash = response.hash;
                    const hashChanged = this.hasHashChanged(this.currentHash, hash);

                    // If new version, do something
                    if (hashChanged) {
                        // ENTER YOUR CODE TO DO SOMETHING UPON VERSION CHANGE
                        // for an example: location.reload();

                        const dialog = this.matDialog.open(ModalInfoComponent, {
                            data: {
                                content: `A new version of this site is available. The site must be updated. We are sorry for the inconvenience.`
                            }
                        });
                        const sub = dialog.afterClosed().subscribe(() => {
                            location.reload();
                        });
                    }
                    // store the new hash so we wouldn't trigger versionChange again
                    // only necessary in case you did not force refresh
                    this.currentHash = hash;
                },
                (err) => {
                    console.error(err, 'Could not get version');
                }
            );
    }

    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     *
     * @param currentHash
     * @param newHash
     * @returns
     */
    private hasHashChanged(currentHash, newHash) {
        if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
            return false;
        }

        return currentHash !== newHash;
    }
}
